import React, { useEffect, useRef } from 'react';
import { Wrapper } from "@googlemaps/react-wrapper";
import '../styles/servicio.css'

function MyMapComponent({
    center,
    zoom,
    onDirections = () => {},
    mapType = "satellite",
    address,
    destination
  }) {
    const ref = useRef();
  
    useEffect(() => {
        let map = new window.google.maps.Map(ref.current, {
            center,
            zoom,
            mapTypeId: mapType,
            address,
            destination
        });
        new window.google.maps.Marker({
            position: center,
            map,
            title: destination,
        });

        const locationButton = document.createElement('button');
        const puntazulInfo = document.createElement('div');

        puntazulInfo.textContent = 'Current Location';
        puntazulInfo.innerHTML = `<div id='staticMapInfo'><b style="margin-bottom: 20px !important">${destination}</b><p>${address ?? "Carretera Autopista Mazatlán Culiacán km 11 maxi pista, Mazatlán, Mexico."}</p></div>`;

        map.controls[window.google.maps.ControlPosition.LEFT_TOP].push(puntazulInfo);

        locationButton.textContent = 'Current Location';
        locationButton.classList.add('custom-map-control-button');
        locationButton.innerHTML = `<div class="icon navigate-icon"></div><span>Cómo llegar</span>`;

        map.controls[window.google.maps.ControlPosition.LEFT_TOP].push(locationButton);
        locationButton.addEventListener('click', () => {
            onDirections()
        });
    }, []);
  
    return <div ref={ref} id="mapDirection" />;
}

export default function MapaDireccion({coordinates, mapType = "satellite", mapaInfo }) {
    const [currentCoordinates, setCurrentCoordinates] = React.useState("");

    const zoom = 17;

    function getCoordinates() {
        if(typeof navigator !== "undefined"){
            navigator.geolocation.getCurrentPosition(function (posicion) {
                let coor = posicion.coords.latitude + ',' + posicion.coords.longitude;
                setCurrentCoordinates(coor);
            });
            
        }
    }

    return currentCoordinates !== "" ? (
        <React.Fragment>
            <iframe title={"MapDireccionSinCoordenadas"} className={"mapServices"} src={`https://www.google.com/maps/embed/v1/directions?key=${process.env.GOOGLE_MAPS_API_KEY}&origin=${currentCoordinates}&destination=${mapaInfo?.destination?.replace(" ", "+") ?? "Puntazul+Residencial"}&zoom=11&maptype=satellite`}></iframe>
        </React.Fragment>
    ) : (   
        <Wrapper apiKey={process.env.GOOGLE_MAPS_API_KEY}>
            <MyMapComponent center={mapaInfo?.coordinates ?? coordinates} zoom={zoom} onDirections={getCoordinates} mapType={mapType} address={mapaInfo?.address} destination={mapaInfo?.destination ?? "Las Puertas D' Mazatlán"} />
        </Wrapper>
    )
}
